import {
  CurrentConsulterQuery,
  useCurrentConsulterQuery,
} from '@/graphql/types'
import React, { createContext, useState, useContext, useEffect } from 'react'

const AuthContext = createContext<{
  isLoggedIn: boolean
  loading: boolean
  currentConsulter?: CurrentConsulterQuery['currentConsulter']
  setCurrentConsulter: (
    value: CurrentConsulterQuery['currentConsulter']
  ) => void
}>({
  isLoggedIn: false,
  loading: true,
  currentConsulter: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCurrentConsulter: () => {},
})

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentConsulter, setCurrentConsulter] = useState<
    CurrentConsulterQuery['currentConsulter']
  >(null)
  const { data, loading } = useCurrentConsulterQuery()
  const isLoggedIn = !!currentConsulter

  useEffect(() => {
    if (!loading && data?.currentConsulter) {
      setCurrentConsulter(data.currentConsulter)
    } else {
      setCurrentConsulter(null)
    }
  }, [loading, data])

  return (
    <AuthContext.Provider
      value={{ isLoggedIn, loading, currentConsulter, setCurrentConsulter }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
